import type { GlobalEvent } from './const';

import EventEmitter3 from 'eventemitter3';

export const EventEmitter = EventEmitter3;

const globalEventEmitter = new EventEmitter3<GlobalEvent>();
export default globalEventEmitter;
